export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readCount: number;
  tags: string[];
  featured: boolean;
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '传奇故事',
    slug: 'legend',
    description: '大爱仙尊的传奇历程，从凡人到仙尊的逆天之路，每一章都扣人心弦，热血沸腾。',
    icon: 'ri-file-text-line',
    articleCount: 12,
  },
  {
    id: 'cat-2',
    name: '修炼体系',
    slug: 'cultivation',
    description: '深度解析大爱仙尊世界的修炼体系，从炼气到仙尊的完整路径，功法、丹药、法宝一应俱全。',
    icon: 'ri-book-open-line',
    articleCount: 8,
  },
  {
    id: 'cat-3',
    name: '热血情缘',
    slug: 'romance',
    description: '大爱仙尊的情感世界，兄弟义气、红颜知己、师徒情深，在仙道路上谱写动人篇章。',
    icon: 'ri-heart-line',
    articleCount: 10,
  },
  {
    id: 'cat-4',
    name: '仙道秘法',
    slug: 'secret-art',
    description: '揭示大爱仙尊掌握的绝世秘法，每一门秘法背后都有一段惊天动地的传说。',
    icon: 'ri-star-line',
    articleCount: 6,
  },
  {
    id: 'cat-5',
    name: '角色图鉴',
    slug: 'characters',
    description: '大爱仙尊世界中的重要角色，正邪两道、仙魔人三界的众生百态尽在其中。',
    icon: 'ri-user-line',
    articleCount: 15,
  },
  {
    id: 'cat-6',
    name: '最新章节',
    slug: 'latest',
    description: '大爱仙尊最新章节第一时间更新，追更不迷路，精彩内容不容错过。',
    icon: 'ri-fire-line',
    articleCount: 20,
  },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '大爱仙尊：从废柴到仙尊的逆袭之路',
    excerpt: '一个被宗门视为废柴的少年，凭借一颗大爱之心，踏上了一条前所未有的修炼之路。从最初被人轻视的炼气期小修士，到最终屹立于万界之巅的仙尊，他的每一步都充满了传奇色彩。',
    content: '在大爱仙尊的世界中，修炼之道千千万万。有人以杀戮证道，有人以无情破境，而大爱仙尊却选择了一条最艰难的道路——以大爱之心，容纳天地万物。\n\n故事始于青云宗的杂役弟子方尘，他天生灵根驳杂，被所有人认为此生无望筑基。然而在一次意外中，他获得了一枚神秘的古玉，其中蕴含着一门早已失传的功法——《大爱无疆诀》。\n\n这门功法的独特之处在于，它不以灵气多寡论高下，而是以修者心中之大爱为根基。爱得越深，修为越强。方尘的传奇，由此展开……',
    category: '传奇故事',
    categorySlug: 'legend',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%20and%20golden%20celestial%20light%2C%20misty%20clouds%2C%20traditional%20ink%20wash%20painting%20style%2C%20warm%20golden%20and%20cinnabar%20red%20accents%2C%20ethereal%20atmosphere%2C%20vertical%20composition%20with%20dramatic%20lighting&width=800&height=500&seq=article-1-cover&orientation=landscape',
    author: '大爱仙尊',
    publishDate: '2026-08-01',
    readCount: 128500,
    tags: ['逆袭', '修炼', '方尘', '青云宗'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '九转金丹诀：仙尊亲传的无上丹道',
    excerpt: '九转金丹诀，乃大爱仙尊独创的炼丹秘法。九转功成，可炼出造化金丹，一枚即可让凡人脱胎换骨，踏入仙途。此丹法融合了上古丹道精髓与大爱仙尊的独特感悟。',
    content: '九转金丹诀，共分九重境界。每一转对应一种天地灵火的掌控，从最初的地火到最终的混沌天火，炼丹的过程本身就是一场修行。\n\n第一转：地火炼丹，需以大地之精为引，淬炼药材中的杂质。\n第二转：木火交融，需寻千年灵木之心为薪，引木中生机入丹。\n第三转：水炼之法，以玄冰之水包裹丹药，水火相济方能成丹。\n……\n第九转：混沌天火，需在九天之上引混沌之力，炼成一枚蕴含天地大道的造化金丹。',
    category: '修炼体系',
    categorySlug: 'cultivation',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20alchemy%20furnace%20with%20glowing%20golden%20pill%2C%20mystical%20flames%20surrounding%20the%20cauldron%2C%20traditional%20Daoist%20laboratory%20in%20a%20cave%2C%20warm%20amber%20and%20gold%20tones%2C%20ink%20wash%20painting%20aesthetic&width=800&height=500&seq=article-2-cover&orientation=landscape',
    author: '丹道散人',
    publishDate: '2026-07-28',
    readCount: 96500,
    tags: ['炼丹', '金丹', '九转', '丹道'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '红颜知己：那些陪伴仙尊走过风雨的女子',
    excerpt: '在大爱仙尊的修炼之路上，有三位红颜知己始终相伴。她们或温柔如水，或冷艳如冰，或热烈如火，每一位都是仙尊心中不可替代的存在，共同书写了一段段动人的情缘。',
    content: '大爱仙尊的感情线，是整个故事中最令人动容的部分。三位红颜知己，三段刻骨铭心的情缘。\n\n柳如烟：青云宗大师姐，温婉贤淑，在方尘最落魄的时候给了他第一份温暖。她不顾宗门反对，暗中帮助方尘修炼，甚至为他触犯门规。\n\n慕容冰：冰宫圣女，冷艳绝伦。她与方尘不打不相识，从对手到知己，两人之间的情愫在一次次生死与共中悄然滋长。\n\n火灵儿：南荒火族公主，热烈奔放。她对方尘一见钟情，为了追随他甘愿放弃王位，陪他走遍天涯海角。',
    category: '热血情缘',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20beauty%20in%20flowing%20silk%20robes%20standing%20among%20peach%20blossoms%20in%20a%20mountain%20valley%2C%20soft%20warm%20lighting%2C%20romantic%20ancient%20Chinese%20fantasy%20atmosphere%2C%20ink%20wash%20painting%20style%20with%20pink%20and%20gold%20accents&width=800&height=500&seq=article-3-cover&orientation=landscape',
    author: '情缘笔客',
    publishDate: '2026-07-25',
    readCount: 152300,
    tags: ['红颜', '情缘', '柳如烟', '慕容冰', '火灵儿'],
    featured: true,
  },
  {
    id: 'article-4',
    title: '万界争锋：大爱仙尊的终极之战',
    excerpt: '当域外天魔降临，万界陷入浩劫，大爱仙尊率众仙迎战。这一战，关乎万界存亡，也是大爱仙尊证道至高仙尊位的终极考验。他以大爱之力，唤醒了沉睡的万界意志。',
    content: '域外天魔，是存在于万界之外的神秘种族。他们以吞噬世界为生，所过之处，星辰陨灭，万物凋零。\n\n当第一波天魔先锋降临天玄大陆，整个修炼界陷入了前所未有的恐慌。金丹期以下的修士在天魔面前毫无还手之力，只有元婴期以上的大能才能勉强一战。\n\n大爱仙尊方尘，此时已踏入大乘期巅峰，距离仙尊之位只差一步。然而面对域外天魔的入侵，他毅然放下了突破的契机，率领万界修士迎战天魔。',
    category: '传奇故事',
    categorySlug: 'legend',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20battle%20scene%20in%20ancient%20Chinese%20fantasy%20style%2C%20celestial%20warriors%20clashing%20with%20dark%20forces%20above%20the%20clouds%2C%20golden%20light%20vs%20darkness%2C%20dramatic%20composition%2C%20ink%20wash%20with%20cinnabar%20red%20and%20gold%20highlights&width=800&height=500&seq=article-4-cover&orientation=landscape',
    author: '大爱仙尊',
    publishDate: '2026-07-22',
    readCount: 189700,
    tags: ['大战', '域外天魔', '仙尊', '终极之战'],
    featured: false,
  },
  {
    id: 'article-5',
    title: '大爱无疆诀：全本功法深度解析',
    excerpt: '大爱无疆诀，是大爱仙尊赖以成名的核心功法。此功法共有九层，层层递进。修炼至大成境界，可凝聚大爱之心，以吾之爱，护佑苍生，成就无上仙尊之位。',
    content: '大爱无疆诀的修炼，与传统的灵气修炼体系截然不同。它不追求灵气的积累速度，而是注重心境的提升和大爱之心的凝聚。\n\n第一层：爱己。修炼者需先学会爱自己，接纳自己的不完美，方能筑基。\n第二层：爱亲。将对亲人的爱意融入修炼之中，以此激发体内潜能。\n第三层：爱友。以真诚之心对待身边的朋友同道，凝聚同道之力。\n……\n第九层：大爱无疆。以爱容纳天地万物，众生平等，万物一心。至此境界，方为真正的仙尊。',
    category: '修炼体系',
    categorySlug: 'cultivation',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20cultivation%20manual%20with%20glowing%20golden%20script%20floating%20in%20the%20air%2C%20mystical%20library%20in%20a%20celestial%20palace%2C%20warm%20golden%20ethereal%20light%2C%20traditional%20ink%20wash%20aesthetic%2C%20sacred%20atmosphere&width=800&height=500&seq=article-5-cover&orientation=landscape',
    author: '修炼研究者',
    publishDate: '2026-07-20',
    readCount: 87500,
    tags: ['功法', '大爱无疆诀', '修炼', '心境'],
    featured: true,
  },
  {
    id: 'article-6',
    title: '灵宝图鉴：大爱仙尊十大至宝',
    excerpt: '大爱仙尊纵横万界，手中掌握着十件震古烁今的至宝。从混沌初开的开天斧，到凝聚大爱之力的大爱仙剑，每一件至宝都蕴含着不可思议的威能，是仙尊实力的重要组成部分。',
    content: '大爱仙尊的十大至宝，每一件都有其独特的来历和威能。\n\n第一名：大爱仙剑——以仙尊本命精血和大爱之力凝聚而成，剑出则天地变色，万灵俯首。\n第二名：混沌珠——蕴含混沌本源之力，可演化一方小世界，是仙尊的洞天法宝。\n第三名：万灵图——可召唤万界生灵之力，与仙尊的大爱之心完美契合。\n第四名：时光沙漏——掌控时间流速，修炼一日可抵外界百年。\n第五名：不灭金身——仙尊的护体至宝，万法不侵，诸邪避退。',
    category: '仙道秘法',
    categorySlug: 'secret-art',
    coverImage: 'https://readdy.ai/api/search-image?query=Collection%20of%20ancient%20Chinese%20mythical%20treasures%20displayed%20on%20a%20celestial%20altar%2C%20glowing%20swords%20and%20artifacts%20with%20golden%20aura%2C%20mystical%20atmosphere%2C%20warm%20gold%20and%20jade%20green%20tones%2C%20ink%20wash%20painting%20style&width=800&height=500&seq=article-6-cover&orientation=landscape',
    author: '藏宝阁主',
    publishDate: '2026-07-18',
    readCount: 103200,
    tags: ['至宝', '仙剑', '法宝', '灵宝'],
    featured: false,
  },
  {
    id: 'article-7',
    title: '青云宗往事：仙尊的起点与初心',
    excerpt: '青云宗，一个位于东荒边陲的二流宗门，却是大爱仙尊修炼之路的起点。在这里，他遇到了生命中最重要的师父和挚友，也经历了人生中第一次生死考验。',
    content: '青云宗虽然只是一座二流宗门，但在大爱仙尊的心中却有着不可替代的地位。\n\n青云宗的宗主青云子，是一位金丹期巅峰的修士。他一眼看出了方尘体内灵根的异常——虽驳杂却暗藏玄机。正是他的暗中栽培，让方尘在最艰难的时候没有放弃修炼。\n\n青云宗的后山禁地中，方尘发现了那枚改变他一生命运的古玉。至今无人知晓，那枚古玉究竟是何人所留，又为何会出现在一个小小的青云宗后山。',
    category: '传奇故事',
    categorySlug: 'legend',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20sect%20on%20misty%20mountain%20peak%2C%20traditional%20wooden%20buildings%20with%20curved%20roofs%2C%20waterfall%20and%20pine%20trees%2C%20morning%20mist%2C%20ink%20wash%20painting%20aesthetic%2C%20serene%20and%20sacred%20atmosphere&width=800&height=500&seq=article-7-cover&orientation=landscape',
    author: '大爱仙尊',
    publishDate: '2026-07-15',
    readCount: 76500,
    tags: ['青云宗', '起点', '师父', '古玉'],
    featured: false,
  },
  {
    id: 'article-8',
    title: '仙尊讲道：修炼一途的十大误区',
    excerpt: '大爱仙尊在九天之上开设道场，为万界修士讲道解惑。今日，仙尊亲述修炼一途中最常见的十大误区，助你避开弯路，直指大道。字字珠玑，句句真言。',
    content: '误区一：盲目追求修炼速度。修炼不是赛跑，快不等于好。根基不稳，速度再快也是空中楼阁。\n\n误区二：忽视心境的修炼。很多人只注重灵气积累和功法修炼，却忽略了心境的提升。实际上，心境的境界决定了你能走多远。\n\n误区三：过度依赖丹药。丹药是辅助，不是根本。真正的强者是靠自己一步步修炼出来的。\n\n误区四：闭门造车。修炼需要交流切磋，闭门造车只会让你在错误的方向上越走越远。\n\n……\n\n误区十：忘记修炼的初心。修炼不是为了炫耀和争强好胜，而是为了守护心中所爱。',
    category: '修炼体系',
    categorySlug: 'cultivation',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20sage%20teaching%20disciples%20on%20a%20mountain%20peak%20surrounded%20by%20clouds%2C%20golden%20celestial%20light%20descending%2C%20serene%20wisdom%20atmosphere%2C%20warm%20and%20sacred%20tones%2C%20ink%20wash%20style&width=800&height=500&seq=article-8-cover&orientation=landscape',
    author: '大爱仙尊',
    publishDate: '2026-07-12',
    readCount: 134600,
    tags: ['修炼', '误区', '讲道', '心得'],
    featured: true,
  },
  {
    id: 'article-9',
    title: '仙魔大战：天魔皇的陨落',
    excerpt: '天魔皇，域外天魔的至高统治者，其实力已超越普通仙尊。大爱仙尊与天魔皇的决战，在九天之外的混沌虚空中展开。这一战打了七天七夜，最终以大爱之力净化了天魔皇。',
    content: '天魔皇的实力深不可测，连大爱仙尊在初次交手中都落于下风。他的力量源自混沌本身的黑暗面，吞噬了无数世界的力量。\n\n决战的第一天，大爱仙尊的大爱仙剑竟无法破开天魔皇的护体魔气。这让所有人都陷入了绝望。\n\n然而在第三天的苦战中，大爱仙尊领悟到了一个关键——天魔皇虽然强大，但他的力量源自恐惧和毁灭。而大爱仙尊的力量，则源自希望和爱。\n\n当大爱仙尊将自己的大爱之心凝聚到极致，万界众生的信念之力汇聚而来，那一刻，天魔皇第一次露出了恐惧的神色。',
    category: '传奇故事',
    categorySlug: 'legend',
    coverImage: 'https://readdy.ai/api/search-image?query=Cosmic%20battle%20between%20celestial%20warrior%20and%20dark%20demon%20lord%20in%20deep%20space%2C%20golden%20light%20piercing%20darkness%2C%20epic%20ancient%20Chinese%20fantasy%2C%20stars%20and%20nebula%20background%2C%20dramatic%20contrast%20of%20light%20and%20shadow&width=800&height=500&seq=article-9-cover&orientation=landscape',
    author: '大爱仙尊',
    publishDate: '2026-07-10',
    readCount: 201300,
    tags: ['天魔皇', '决战', '大爱之力', '净化'],
    featured: true,
  },
  {
    id: 'article-10',
    title: '仙尊后宫：大爱之下的一世深情',
    excerpt: '有人说大爱仙尊花心，实则不然。他的每一段情缘都是真心付出，每一位红颜都是他用生命去守护的人。大爱不是滥情，而是以真心对待每一个走进他生命的人。',
    content: '柳如烟，是方尘的初恋，也是最懂他的人。他们从小一起在青云宗长大，柳如烟见证了方尘从废柴到强者的每一步蜕变。\n\n慕容冰，与方尘惺惺相惜。两人在修炼上互相印证，在战斗中默契配合。慕容冰的冷，是对方尘以外所有人的冷。\n\n火灵儿，是方尘生命中最炽热的一抹色彩。她的到来让方尘明白了爱的另一种可能——毫无保留，轰轰烈烈。\n\n大爱仙尊从不回避自己的感情。在他看来，真正的强者不是无情，而是敢于面对自己的每一份情感。',
    category: '热血情缘',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20ancient%20Chinese%20palace%20garden%20with%20cherry%20blossoms%20and%20moonlit%20pond%2C%20soft%20pink%20and%20gold%20atmosphere%2C%20traditional%20architecture%2C%20dreamy%20and%20ethereal%2C%20ink%20wash%20with%20warm%20romantic%20tones&width=800&height=500&seq=article-10-cover&orientation=landscape',
    author: '情缘笔客',
    publishDate: '2026-07-08',
    readCount: 178900,
    tags: ['情缘', '红颜', '深情', '后宫'],
    featured: false,
  },
  {
    id: 'article-11',
    title: '秘境探秘：大爱仙尊发现的十大上古秘境',
    excerpt: '大爱仙尊在万界游历中，发现了许多尘封已久的上古秘境。这些秘境中蕴含着远古大能留下的机缘与考验，每一处秘境都有一段惊心动魄的探险故事。',
    content: '上古秘境，是远古时代的大能们留下的洞府遗迹。大爱仙尊在历练中发现了十处最重要的秘境。\n\n第一秘境：太虚古墓。位于东荒极东之地，是一位太虚境大能的陨落之地。方尘在此获得了太虚传承。\n\n第二秘境：不死火山。传说中有不死神凰的涅槃之地，蕴含火之本源。\n\n第三秘境：万剑冢。上古剑仙的埋剑之处，万柄神剑在此沉睡，等待有缘人。\n\n……\n\n每一个秘境都伴随着巨大的危险，但收获同样惊人。',
    category: '仙道秘法',
    categorySlug: 'secret-art',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20ruins%20hidden%20deep%20in%20mountains%20with%20glowing%20runes%2C%20overgrown%20temples%2C%20golden%20light%20emanating%20from%20ancient%20doorways%2C%20misty%20and%20mystical%2C%20ink%20wash%20style&width=800&height=500&seq=article-11-cover&orientation=landscape',
    author: '秘境探险家',
    publishDate: '2026-07-05',
    readCount: 89200,
    tags: ['秘境', '探险', '上古', '机缘'],
    featured: false,
  },
  {
    id: 'article-12',
    title: '方尘传：大爱仙尊完整人物志',
    excerpt: '方尘，道号大爱仙尊，出生于东荒青云城的一个普通修士家庭。从炼气期小修士到万界至尊，他用了三千年。这份人物志，记录了大爱仙尊波澜壮阔的一生。',
    content: '方尘，出生于青云城方家旁支。父亲方天德是炼气九层的散修，母亲柳氏是凡人。\n\n幼年的方尘显示出惊人的修炼天赋，三岁引气入体，五岁炼气一层。然而七岁时灵根测试的结果却让所有人失望——五行灵根驳杂，被判定此生无望筑基。\n\n十五岁那年，方尘在青云宗后山意外发现神秘古玉，开启了大爱无疆诀的传承。从此，他的命运彻底改变。\n\n二十岁筑基，五十岁金丹，两百岁元婴，五百岁化神，一千岁合体，两千岁大乘。三千岁时，方尘以大爱之心突破最后一道瓶颈，成就仙尊之位。',
    category: '角色图鉴',
    categorySlug: 'characters',
    coverImage: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20ancient%20Chinese%20immortal%20hero%20in%20flowing%20white%20robes%20standing%20on%20a%20mountain%20peak%2C%20golden%20celestial%20glow%20behind%2C%20dignified%20and%20powerful%20presence%2C%20ink%20wash%20with%20warm%20golden%20light&width=800&height=500&seq=article-12-cover&orientation=landscape',
    author: '史官仙笔',
    publishDate: '2026-07-02',
    readCount: 245600,
    tags: ['方尘', '人物志', '传记', '仙尊'],
    featured: true,
  },
];